import PropTypes from 'prop-types';

function SwitchButton({ isActive, doSwitch, text }) {
	return (
		<div className="switch-button">
			<div className={'switch-button__switch' + (isActive ? ' switch-button__switch--active' : '')} onClick={doSwitch}>
				<span className="switch-button__switch-lever"></span>
			</div>
			{text}
		</div>
	);
}

SwitchButton.propTypes = {
	isActive: PropTypes.bool,
	doSwitch: PropTypes.func,
	text: PropTypes.string,
};

SwitchButton.defaultProps = {
	isActive: false,
};

export default SwitchButton;
